

function TopPannel() {
    return (
        <div>
            <h1>Today, our menu looks like this</h1>
        </div>
    )
}

export default TopPannel;